import * as DashboardModels from '../../models/dashboard/dashboard';
import * as Models from '../../models/commonModels';

export class GetWebPageList {
  static readonly type = '[WebPage] List';
  constructor(public Search: DashboardModels.WebPageSearchRequestModel) { }
}

export class GetWebPageActiveList {
  static readonly type = '[WebPage] Active List';
  constructor() { }
}

export class GetWebPage {
  static readonly type = '[WebPage] Get';
  constructor(public WebPage: Models.RequestModel) { }
}

export class SetWebPage {
  static readonly type = '[WebPage] Set';
  constructor(public WebPage: Models.Request<DashboardModels.WebPageModel>) { }
}

export class DeleteWebPage {
  static readonly type = '[WebPage] Delete';
  constructor(public WebPage: Models.Request<DashboardModels.WebPageModel>) { }
}



export class GetWebPageTypeList {
  static readonly type = '[WebPage] WebPageType List';
  constructor() { }
}


export class GetDownloadList {
  static readonly type = '[Download] List';
  constructor(public Search: DashboardModels.DownloadSearchRequestModel) { }
}

export class GetDownloadActiveList {
  static readonly type = '[Download] Active List';
  constructor() { }
}

export class GetDownload {
  static readonly type = '[Download] Get';
  constructor(public Download: Models.RequestModel) { }
}

export class SetDownload {
  static readonly type = '[Download] Set';
  constructor(public Download: Models.Request<DashboardModels.DownloadModel>) { }
}

export class DeleteDownload {
  static readonly type = '[Download] Delete';
  constructor(public Download: Models.Request<DashboardModels.DownloadModel>) { }
}

export class SetDownloadDocument {
  static readonly type = '[Download] Set Download Document';
  constructor(public Inventory: Models.Request<DashboardModels.DownloadModel>, public File: File) { }
}

export class GetDownloadDocument {
  static readonly type = '[Download] Get Download Documentl';
  constructor(public Inventory: Models.Request<DashboardModels.DownloadModel>) { }
}





export class GetTyreChange {
  static readonly type = '[WebPage] GetTyreChange';
  constructor() {}
}



export class GetDownloadTypeList {
  static readonly type = '[DownloadType] GetDownloadTypeList';
  constructor() {}
}

export class GetDownloadType {
  static readonly type = '[DownloadType] GetDownloadType';
  constructor(public DownloadType: Models.RequestModel) { }
}

export class SetDownloadType {
  static readonly type = '[DownloadType] SetDownloadType';
  constructor(public DownloadType: Models.Request<DashboardModels.DownloadTypeModel>) { }
}

export class DeleteDownloadType {
  static readonly type = '[DownloadType] DeleteDownloadType';
  constructor(public DownloadType: Models.Request<DashboardModels.DownloadTypeModel>) { }
}
